import { render, staticRenderFns } from "./SingleRide.vue?vue&type=template&id=6c34ddc4&scoped=true"
import script from "./SingleRide.vue?vue&type=script&lang=js"
export * from "./SingleRide.vue?vue&type=script&lang=js"
import style0 from "./SingleRide.vue?vue&type=style&index=0&id=6c34ddc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34ddc4",
  null
  
)

export default component.exports